import React from 'react';
import PropTypes from 'prop-types';
import { iconTrashcan } from 'utils/svgConstants';

export default function TrashCan({ disabled, keyPath, onDelete }) {
  const onClick = (event) => {
    event.stopPropagation();
    onDelete(event);
  };
  return (
    <span className="d-inline-flex">
      <button disabled={disabled} type="button" id={`${[...keyPath, 'btn-delete'].join('-')}`} className="p-0" aria-label="Delete" onClick={onClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-labelledby="title" className={`${disabled ? 'trash-can--disabled' : ''}`}>
          <title>{disabled ? 'This field cannot be deleted' : 'Delete'}</title>
          <path d={iconTrashcan} />
        </svg>
      </button>
    </span>
  );
}

TrashCan.propTypes = {
  disabled: PropTypes.bool.isRequired,
  keyPath: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
};
